"use strict";

/*globals ajaxify, config, utils, app, socket, NProgress*/

$(document).ready(function() {

	// Pour le padding-top dynamique du #panel
	var paddingtoppanel;
	var mystickysidebar;

	setupNProgress();
	setupTaskbar();
	setupEditedByIcon();
	setupMobileMenu();
	setupQuickReply();
	fixHeaderPadding();

	$(window).on('action:app.loggedOut', function (event, data) {
		// Redirect to /login after logout...
		data['next']='/login';
	});

	$(window).on('resize action:topics.loaded action:posts.loaded action:ajaxify.end', fixHeaderPadding);

	$(window).on('action:app.loggedIn', function () {
		setupMobileMenu();
		fixHeaderPadding();
	});

	function fixHeaderPadding() {
		var paddingtoppanelnew = $('#header-menu').outerHeight(true) - 5;
		if (paddingtoppanelnew != paddingtoppanel) {
			paddingtoppanel = paddingtoppanelnew;
			$('#panel').css('padding-top', paddingtoppanel);
		}
		stickMySidebar();
	}

	function stickMySidebar () {
		// Yannick made...
		// Pour avoir le comportement sticky sur la sidebar...
		requirejs(['oxide/sticky', 'oxide/resizesensor'], function(sticky,ResizeSensor) {
			mystickysidebar = $('.sticky-sidebar').stickySidebar({
				containerSelector: '.corps-droite',
				innerWrapperSelector: '.sticky-sidebar-inner',
				minWidth: 817, // no stick if one column...
				topSpacing: function () {
						// on the fly value
						return paddingtoppanel + 1;
					}
			});
			mystickysidebar.stickySidebar('updateSticky');
		});
	}


	function configureNavbarHiding() {
		var navbarEl = $(".navbar-fixed-top");
		navbarEl.autoHidingNavbar('destroy');
		navbarEl.css('top', '');

		var env = utils.findBootstrapEnvironment();
		if (env === 'xs' || env === 'sm') {
			navbarEl.autoHidingNavbar({
				showOnBottom: false,
			});
		}
	}

	function setupNProgress() {
		$(window).on('action:ajaxify.start', function() {
			NProgress.set(0.7);
		});

		$(window).on('action:ajaxify.end', function(ev, data) {
			NProgress.done();
			setupHoverCards();
		});
	}

	function setupTaskbar() {
		$(window).on('filter:taskbar.push', function (ev, data) {
			data.options.className = 'taskbar-' + data.module;

			if (data.module === 'composer') {
				data.options.icon = 'fa-commenting-o';
			} else if (data.module === 'chat') {
				if (!data.element.length) {
					createChatIcon(data);
					$(window).one('action:taskbar.pushed', function (ev, data) {
						updateChatCount(data.element);
					});

				} else if (!data.element.hasClass('active')) {
					updateChatCount(data.element);
				}
			}
		});

		socket.on('event:chats.markedAsRead', function (data) {
			$('#taskbar [data-roomId="' + data.roomId + '"]')
				.removeClass('new')
				.attr('data-content', 0);
		});

		function createChatIcon(data) {
			$.getJSON(config.relative_path + '/api/user/' + app.user.userslug + '/chats/' + data.options.roomId, function (chatObj) {
				var el = $('#taskbar [data-uuid="' + data.uuid + '"] a');
				el.parent('[data-uuid]').attr('data-roomId', data.options.roomId);

				if (chatObj.users.length === 1) {
					var user = chatObj.users[0];
					el.find('i').remove();

					if (user.picture) {
						el.css('background-image', 'url(' + user.picture + ')');
					} else {
						el.css('background-color', user['icon:bgColor'])
							.text(user['icon:text'])
							.addClass('user-icon');
					}
				}
			});
		}

		function updateChatCount(el) {
			var count = (parseInt($(el).attr('data-content'), 10) || 0) + 1;
			$(el).attr('data-content', count);
		}
	}

	function setupEditedByIcon() {
		function activateEditedTooltips() {
			$('[data-pid] [component="post/editor"]').each(function() {
				var el = $(this), icon;

				if (!el.attr('data-editor')) {
					return;
				}

				icon = el.closest('[data-pid]').find('.edit-icon').first();
				icon.prop('title', el.text()).tooltip('fixTitle').removeClass('hidden');
			});
		}

		$(window).on('action:posts.edited', function(ev, data) {
			var parent = $('[data-pid="' + data.post.pid + '"]');
			var icon = parent.find('.edit-icon').filter(function (index, el) {
				return parseInt($(el).closest('[data-pid]').attr('data-pid'), 10) === parseInt(data.post.pid, 10);
			});
			var el = parent.find('[component="post/editor"]').first();
			icon.prop('title', el.text()).tooltip('fixTitle').removeClass('hidden');
		});

		$(window).on('action:topic.loaded', activateEditedTooltips);
		$(window).on('action:posts.loaded', activateEditedTooltips);
	}

	function setupMobileMenu() {
		if (!window.addEventListener) {
			return;
		}

		require(['pulling', 'storage'], function (Pulling, Storage) {
			// initialization

			var chatMenuVisible = !config.disableChat && app.user && parseInt(app.user.uid, 10);
			var margin = window.innerWidth;

			var navSlideout = Pulling.create({
				panel: document.getElementById('panel'),
				menu: document.getElementById('menu'),
				width: 256,
				margin: margin,
				side: 'left',
			});
			$('#menu').removeClass('hidden');

			var chatsSlideout;
			if (chatMenuVisible) {
				chatsSlideout = Pulling.create({
					panel: document.getElementById('panel'),
					menu: document.getElementById('chats-menu'),
					width: 256,
					margin: margin,
					side: 'right',
				});
				$('#chats-menu').removeClass('hidden');
			}

			// all menus

			function closeOnClick() {
				navSlideout.close();
				if (chatsSlideout) { chatsSlideout.close(); }
			}

			function onBeforeOpen() {
				document.documentElement.classList.add('slideout-open');
			}

			function onClose() {
				$('#mobile-menu').blur();
				document.documentElement.classList.remove('slideout-open');
				$('#panel').off('click', closeOnClick);
			}

			$(window).on('resize action:ajaxify.start', function () {
				navSlideout.close();
				if (chatsSlideout) { chatsSlideout.close(); }
				$('.account .cover').css('top', $('[component="navbar"]').height());
			});

			navSlideout
				.ignore('code, code *, .preventSlideout, .preventSlideout *')
				.on('closed', onClose)
				.on('beforeopen', onBeforeOpen)
				.on('opened', function () {
					$('#panel').one('click', closeOnClick);
				});

			if (chatMenuVisible) {
				chatsSlideout
					.ignore('code, code *, .preventSlideout, .preventSlideout *')
					.on('closed', onClose)
					.on('beforeopen', onBeforeOpen)
					.on('opened', function () {
						$('#panel').one('click', closeOnClick);
					});
			}

			// left slideout navigation menu

			$('#mobile-menu').on('click', function () {
				navSlideout.enable().toggle();
			});

			function loadNotifications() {
				require(['notifications'], function(notifications) {
					notifications.loadNotifications($('#menu [data-section="notifications"] ul'));
				});
			}

			navSlideout.on('opened', loadNotifications);

			if (chatMenuVisible) {
				navSlideout.on('beforeopen', function () {
					chatsSlideout.close();
					chatsSlideout.disable();
				}).on('closed', function () {
					chatsSlideout.enable();
				});
			}

			$('#menu [data-section="navigation"] ul').html($('#main-nav').html() + ($('#search-menu').html() || '') + ($('#logged-out-menu').html() || ''));
			$('#user-control-list').children().clone(true, true).appendTo($('#menu [data-section="profile"] ul'));

			// right slideout chats menu

			function loadChats() {
				require(['chat'], function (chat) {
					chat.loadChatsDropdown($('#chats-menu .chat-list'));
				});
			}

			if (chatMenuVisible) {
				$('#mobile-chats').removeClass('hidden').on('click', function() {
					navSlideout.close();
					chatsSlideout.enable().toggle();
				});
				$('#chats-menu').on('click', 'li[data-roomid]', function () {
					chatsSlideout.close();
				});

				chatsSlideout
					.on('opened', loadChats)
					.on('beforeopen', function () {
						navSlideout.close().disable();
					})
					.on('closed', function () {
						navSlideout.enable();
					});
			}
		});
	}

	function setupHoverCards() {
		require(['components'], function (components) {
			components.get('topic')
				.on('click', '[component="user/picture"],[component="user/status"]', generateUserCard);
		});

		$(window).on('action:posts.loading', function (ev, data) {
			for (var i = 0, ii = data.posts.length; i < ii; i++) {
				(ajaxify.data.topics || ajaxify.data.posts)[data.posts[i].index] = data.posts[i];
			}
		});
	}

	function generateUserCard(ev) {
		var avatar = $(this),
			index = avatar.parents('[data-index]').attr('data-index'),
			data = (ajaxify.data.topics || ajaxify.data.posts);

		for (var i = 0, ii = data.length; i < ii; i++) {
			if (parseInt(data[i].index, 10) === parseInt(index, 10)) {
				data = data[i].user;
				break;
			}
		}

		$('.oxide-usercard').remove();

		if (parseInt(data.uid, 10) === 0) {
			return false;
		}

		app.parseAndTranslate('modules/usercard', data, function(html) {
			var card = $(html);
			avatar.parents('a').after(card.hide());
			utils.makeNumbersHumanReadable(card.find('.human-readable-number'));
			setupCardRemoval(card);
			card.fadeIn();
		});

		ev.preventDefault();
		return false;
	}

	function setupCardRemoval(card) {
		function removeCard(ev) {
			if ($(ev.target).closest('.oxide-usercard').length === 0) {
				card.fadeOut(function() {
					card.remove();
				});

				$(document).off('click', removeCard);
			}
		}

		$(document).on('click', removeCard);
	}


	function setupQuickReply() {
		$(window).on('action:ajaxify.end', function(ev, data) {
			if (data.url && data.url.match('^topic/') && config.enableQuickReply) {
				require(['oxide/quickreply'], function(quickreply) {
					quickreply.init();
				});
			}
		});
	}

// Yannick
// Ajout pour masonry de la page des catégories...
//
	requirejs(['oxide/masonry'], function(Masonry) {
		var masonry;
		var masonryCalled = false;

		function doMasonry() {
			masonryCalled = true;
			if ($('.masonry').length) {
				masonry = new Masonry('.masonry', {
					itemSelector: '.masonry-item',
					columnWidth: '.masonry-item:not(.col-lg-12)',
					gutter: 0,
					horizontalOrder: true,
					transitionDuration: '0.2s',
					percentPosition: true,
					initLayout: false
				});

				masonry.layout();

			}
		}

		$(window).on('action:ajaxify.end', function(ev, data) {
			doMasonry();
		});

		if ($('.masonry').length && !masonryCalled) {
			doMasonry();
		}
	});


///////////////
// Ajout pour la copie du lien direct vers un message
//////////////

	function fallbackCopyTextToClipboard(text) {
		// Version plus ancienne pour copie dans le presse-papier
		var textArea = document.createElement("textarea");

		// Avoid scrolling to bottom etc...
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";
		textArea.style.width = '1px';
		textArea.style.height = '1px';
		textArea.style.padding = 0;
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';
		textArea.style.background = 'transparent';

 		document.body.appendChild(textArea);
		textArea.value = text;
 		textArea.focus();
		textArea.select();

		try {
			var successful = document.execCommand('copy');
// 			var msg = successful ? 'successful' : 'unsuccessful';
// 			console.log('Fallback: Copying text command was ' + msg);
// 			console.log('Texte copié : ' + text);
		} catch (err) {
			bootbox.alert('Votre navigateur n\'est pas assez récent pour supporter les fonctionnalités de copie avancée. Désolé !');
		}

		document.body.removeChild(textArea);
	}

	function CopyTextToClipboard(text) {
		// Pour copie dans le presse-papier
		if (!navigator.clipboard) {
			// Cas plus ancien
			fallbackCopyTextToClipboard(text);
			return;
		}
		// Cas plus récent (mieux et async)
		navigator.clipboard.writeText(text).then(function() {
// 			console.log('Async: Copying to clipboard was successful!');
		}, function(err) {
			bootbox.alert('Il y a un problème avec de support de Clipboard API avec votre navigateur. Vous ne pouvez pas profiter des fonctionnalités de copie avancée. Désolé !');
// 			console.error('Async: Could not copy text: ', err);
		});
	}

	$(document.body).on('click', '[component="post/copylink"]', function () {
		var baseUrl = window.location.protocol + '//' + window.location.host;
		var pid = $(this).parents('[data-pid]').attr('data-pid');
		var postlink = baseUrl + '/post/' + pid;
		CopyTextToClipboard(postlink);
// 		bootbox.alert('<label>Le lien suivant a été copié dans le presse-papier :</label> ' + postlink);
	});

///////////////
// Ajout pour l'affichage du code source d'un message
//////////////
	$(document.body).on('click', '[component="post/sourcecode"]', function () {
		var pid = $(this).parents('[data-pid]').attr('data-pid');
		socket.emit('posts.getRawPost', pid, function (err, post) {
			if (err) {
				return app.alertError(err.message);
			}
			var message = "<label>Code source du message n°" + pid + "</label><br><textarea rows='10' style='width: 100%; max-width:100%; resize: vertical;' readonly>" + post + "</textarea>";
			bootbox.alert({
				message: message,
				buttons: {
					ok: {
						label: 'Fermer'
					}
				}
			});
		});
	});


///////////////
// Ajouts pour le copier-coller de formules KaTeX (adapté à partir de l'extension copy-tex dans katex)
//////////////

	// Set these to how you want inline and display math to be delimited.
	const defaultCopyDelimiters = {
	inline: ['$', '$'],    // alternative: ['\(', '\)']
	display: ['$$', '$$'], // alternative: ['\[', '\]']
	};

	// Replace .katex elements with their TeX source (<annotation> element).
	// Modifies fragment in-place.  Useful for writing your own 'copy' handler,
	// as in copy-tex.js.
	const katexReplaceWithTex = function(fragment, copyDelimiters = defaultCopyDelimiters) {
		// Remove .katex-html blocks that are preceded by .katex-mathml blocks
		// (which will get replaced below).
		const katexHtml = fragment.querySelectorAll('.katex-mathml + .katex-html');
		for (let i = 0; i < katexHtml.length; i++) {
			const element = katexHtml[i];
			if (element.remove) {
			element.remove(null);
			} else {
			element.parentNode.removeChild(element);
			}
		}
		// Replace .katex-mathml elements with their annotation (TeX source)
		// descendant, with inline delimiters.
		const katexMathml = fragment.querySelectorAll('.katex-mathml');
		for (let i = 0; i < katexMathml.length; i++) {
			const element = katexMathml[i];
			const texSource = element.querySelector('annotation');
			if (texSource) {
			if (element.replaceWith) {
				element.replaceWith(texSource);
			} else {
				element.parentNode.replaceChild(texSource, element);
			}
			texSource.innerHTML = copyDelimiters.inline[0] +
				texSource.innerHTML + copyDelimiters.inline[1];
			}
		}
		// Switch display math to display delimiters.
		const displays = fragment.querySelectorAll('.katex-display annotation');
		for (let i = 0; i < displays.length; i++) {
			const element = displays[i];
			element.innerHTML = copyDelimiters.display[0] +
			element.innerHTML.substr(copyDelimiters.inline[0].length,
				element.innerHTML.length - copyDelimiters.inline[0].length
				- copyDelimiters.inline[1].length)
			+ copyDelimiters.display[1];
		}
		return fragment;
	};

	// Global copy handler to modify behavior on .katex elements.
	document.addEventListener('copy', function(event) {
		const selection = window.getSelection();
		if (selection.isCollapsed) {
			return;  // default action OK if selection is empty
		}
		const fragment = selection.getRangeAt(0).cloneContents();
		if (!fragment.querySelector('.katex-mathml')) {
			return;  // default action OK if no .katex-mathml elements
		}
		// Preserve usual HTML copy/paste behavior.
		const html = [];
		for (let i = 0; i < fragment.childNodes.length; i++) {
			html.push(fragment.childNodes[i].outerHTML);
		}
		event.clipboardData.setData('text/html', html.join(''));
		// Rewrite plain-text version.
		event.clipboardData.setData('text/plain',
			katexReplaceWithTex(fragment).textContent);
		// Prevent normal copy handling.
		event.preventDefault();
	});

});

